import React from 'react';
import CountUp from 'react-countup';
import { Card, CardBody, Row, Col } from 'reactstrap';

export const BillsToPayCards = ({ data }) => {
  return (
    <Row>
      <Col md={3}>
        <Card className="bg-primary m-3">
          <CardBody>
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-shrink-0">
                <i className="ri-calendar-2-fill display-6 text-light"></i>
              </div>
              <div className="ms-3">
                <h2 className="mb-0">
                  <span className="counter-value text-light fw-semibold">
                    R${' '}
                    <CountUp
                      separator="."
                      start={0}
                      end={data.pendent}
                      decimals={0}
                      duration={0}
                      formattingFn={(value) =>
                        value.toLocaleString(
                          undefined, // leave undefined to use the visitor's browser
                          // locale or a string like 'en-US' to override it.
                          { minimumFractionDigits: 2 }
                        )
                      }
                    />
                  </span>
                  <span className="d-block text-light text-uppercase fw-light fs-12 text-end">
                    Total Pendente
                  </span>
                </h2>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col md={3}>
        <Card className="bg-primary m-3">
          <CardBody>
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-shrink-0">
                <i className="ri-calendar-todo-fill display-6 text-light"></i>
              </div>
              <div className="ms-3">
                <h2 className="mb-0">
                  <span className="counter-value text-light fw-semibold">
                    R${' '}
                    <CountUp
                      separator="."
                      start={0}
                      end={data.prospective}
                      decimals={0}
                      duration={0}
                      formattingFn={(value) =>
                        value.toLocaleString(
                          undefined, // leave undefined to use the visitor's browser
                          // locale or a string like 'en-US' to override it.
                          { minimumFractionDigits: 2 }
                        )
                      }
                    />
                  </span>
                  <span className="d-block text-light text-uppercase fw-light fs-12 text-end">
                    Total em Dia
                  </span>
                </h2>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col md={3}>
        <Card className="bg-primary m-3">
          <CardBody>
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-shrink-0">
                <i className="ri-alert-line display-6 text-light"></i>
              </div>
              <div className="ms-3">
                <h2 className="mb-0">
                  <span className="counter-value text-light fw-semibold">
                    R${' '}
                    <CountUp
                      separator="."
                      start={0}
                      end={data.overdue}
                      decimals={0}
                      duration={0}
                      formattingFn={(value) =>
                        value.toLocaleString(
                          undefined, // leave undefined to use the visitor's browser
                          // locale or a string like 'en-US' to override it.
                          { minimumFractionDigits: 2 }
                        )
                      }
                    />
                  </span>
                  <span className="d-block text-light text-uppercase fw-light fs-12 text-end">
                    Total em Atraso
                  </span>
                </h2>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      <Col md={3}>
        <Card className="bg-primary m-3">
          <CardBody>
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-shrink-0">
                <i className="ri-calendar-check-fill display-6 text-light"></i>
              </div>
              <div className="ms-3">
                <h2 className="mb-0">
                  <span className="counter-value text-light fw-semibold">
                    R${' '}
                    <CountUp
                      separator="."
                      start={0}
                      end={data.paid}
                      decimals={0}
                      duration={0}
                      formattingFn={(value) =>
                        value.toLocaleString(
                          undefined, // leave undefined to use the visitor's browser
                          // locale or a string like 'en-US' to override it.
                          { minimumFractionDigits: 2 }
                        )
                      }
                    />
                  </span>
                  <span className="d-block text-light text-uppercase fw-light fs-12 text-end">
                    Total Pago
                  </span>
                </h2>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};
